import React from 'react';

import { Path } from '@edx/graphql/generated';
import PathsPage from '@edx/pages/paths/index';

export { getStaticProps } from '@edx/pages/paths';

// @TODO: CHANGE THIS
const bgImage = {
  large: '/img/paths/paths_heading-l.jpg',
  medium: '/img/paths/paths_heading-m.jpg',
  small: '/img/paths/paths_heading-s.jpg',
};

type Props = {
  paths: Path[];
};

const ItinerariosPage: React.FC<Props> = ({ paths }) => <PathsPage bgImage={bgImage} paths={paths} />;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ItinerariosPage.navBar = { position: 'absolute', variant: 'transparent' };

export default ItinerariosPage;
